export * from './supercard';

//# sourceMappingURL=index.js.map